exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".projectSwitcher_container__3P1x6{display:flex;flex-direction:column;width:25rem}.projectSwitcher_menuContainer__1daZ3{overflow-y:auto;height:25rem}.projectSwitcher_filter__2z0UZ{margin:0 1rem}.projectSwitcher_filterFieldContainer__2yWyi{width:100%}.projectSwitcher_groupName__QFcSJ{background-color:hsla(0,0%,60%,.08);padding:.5rem 1.125rem;font-size:.9375rem}.projectSwitcher_empty__3bdIj{padding:.625rem}", ""]);

// exports
exports.locals = {
	"container": "projectSwitcher_container__3P1x6",
	"menuContainer": "projectSwitcher_menuContainer__1daZ3",
	"filter": "projectSwitcher_filter__2z0UZ",
	"filterFieldContainer": "projectSwitcher_filterFieldContainer__2yWyi",
	"groupName": "projectSwitcher_groupName__QFcSJ",
	"empty": "projectSwitcher_empty__3bdIj"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/Navbar/projectSwitcher.less
// module id = 1386
// module chunks = 8